import React, { useEffect, useState } from 'react';
import { DealerAccordionItemHeaderWrapper } from '../styles/FilterOverlay.styles';
import { Checkbox, IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';
export const DealerAccordionItemHeader = ({ id, panelId, count, label, dealerStatus, active, open, ariaLabelForAccordionButton, isCheckedControlledByClickOnMarker, isDisplayingFocusedDealerBellowMap, toggleRef, setSelectedDealer, handleToggle, }) => {
    const arrowIcon = open ? 'arrow-up' : 'arrow-down';
    const arrowIconReverted = open ? 'arrow-down' : 'arrow-up';
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        if (setSelectedDealer) {
            setSelectedDealer({ dealerId: id, source: 'checkbox' });
        }
    };
    useEffect(() => {
        if (isCheckedControlledByClickOnMarker !== undefined) {
            setIsChecked(isCheckedControlledByClickOnMarker);
        }
    }, [isCheckedControlledByClickOnMarker]);
    useEffect(() => {
        if (active !== undefined) {
            setIsChecked(active);
        }
    }, [active]);
    return (React.createElement(DealerAccordionItemHeaderWrapper, { status: dealerStatus, open: open, isDisplayingFocusedDealerBellowMap: isDisplayingFocusedDealerBellowMap },
        React.createElement(StyledCheckbox, { checked: isChecked, id: `checkbox_${id}`, disabled: count === 0, name: `checkbox_${id}`, value: `checkbox_${id}`, label: label, onChange: () => handleCheckboxChange() }),
        React.createElement(StyledIconButton, { icon: isDisplayingFocusedDealerBellowMap ? arrowIconReverted : arrowIcon, variant: "tertiary", id: id, size: "sm", "aria-controls": panelId, "aria-expanded": open, "aria-label": ariaLabelForAccordionButton, onClick: handleToggle, ref: toggleRef })));
};
const StyledCheckbox = styled((props) => React.createElement(Checkbox, Object.assign({}, props))) `
  margin: 16px ${SYS_SPACE_FIXED_150};
`;
const StyledIconButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  > button:hover,
  > button:active {
    background: unset !important;
    border-color: unset !important;
    border: unset !important;
  }
  > button {
    transition: none !important;
  }
`;
